import  gql  from 'graphql-tag'

export const CREATE_CREDIT_PURPOSE = gql`mutation creditPurpose($input: CreditPurposeMutationInput!){
    creditPurpose(input: $input){
        creditPurpose{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;